export const homeData = {
    name: 'Faris Rehman',
    birthDate: new Date('1999-07-01'),
    introduction: {
        greeting: "Hi! I'm",
        description: ' Computer Scientist interested in working with data structures to solve real-world problems.',
        background:
            'Programming since the age of 9, I have learnt multiple programming languages, gaining experience with them by completing various projects.',
        currentWork: {
            company: 'Goldman Sachs',
            companyUrl: 'https://www.goldmansachs.com',
            team: 'FX Systematic Market Making Engineering',
            teamUrl: 'https://www.goldmansachs.com/what-we-do/ficc-and-equities',
            role: 'Associate Java Software Engineer',
            teamShort: 'FX FICC SMM Eng',
        },
    },
    openSource: {
        title: 'Open Source',
        subtitle: 'View my open source projects and code.',
        links: {
            github: {
                url: 'https://github.com/FarisR99',
                label: 'GitHub',
            },
            gist: {
                url: 'https://gist.github.com/FarisR99',
                label: 'Gist',
            },
        },
    },
    social: {
        linkedin: 'https://www.linkedin.com/in/faris-r-905310b2/',
    },
};
